import React, { useEffect } from 'react';

import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';

import { setVerificationCodeTimerStatus } from 'redux/app/app.actions';
import VerificationForm from './VerificationForm';
import { resendVerificationSmsStart } from 'redux/user/user.actions';
import { useTimer } from 'hooks';
import useTranslation from 'hooks/useTranslation';
import './styles.scss';

const getUnregisteredUser = ({ appData }) => appData.unregisteredUser;
const getProfile = ({ userData }) => userData.profile;

const VerificationCard = () => {
  const unregisteredUser = useSelector(getUnregisteredUser);
  const profile = useSelector(getProfile);
  const dispatch = useDispatch();

  const { verificationCodeTimer, isTimerStarted } = useTimer();

  const { mobile } = unregisteredUser || profile;

  const { getTranslation, getAppLocale } = useTranslation('COMMON');
  const { t } = getTranslation();
  const locale = getAppLocale();

  const getDescription = (locale) => {
    if (locale === 'en') {
      return <>Please enter 4 digit code sent to {mobile} mobile number.</>;
    }

    return (
      <>
        لطفا کد ۴ رقمی ارسال شده به شماره‌ موبایل‌
        <span className='signup_verify_mobile_num'> {mobile} </span>
        را وارد نمایید.
      </>
    );
  };

  const handleResend = (event) => {
    event.preventDefault();
    if (isTimerStarted) return false;
    dispatch(resendVerificationSmsStart(mobile));
  };

  useEffect(() => {
    if (!isTimerStarted) {
      dispatch(setVerificationCodeTimerStatus(true));
    }
  }, [isTimerStarted]);

  return (
    <div className='signup_box'>
      <h4>{t('VERIFY_CARD').TITLE}</h4>
      <p className='description'>{getDescription(locale)}</p>
      <VerificationForm mobile={mobile} />
      <div className='sendverify flex'>
        <div className='sendverify__sendagain'>
          {t('VERIFY_CARD').NOT_RECIEVED}
          <a
            href={isTimerStarted ? null : '#/'}
            onClick={handleResend}
            className={clsx(isTimerStarted && 'disabled')}
          >
            {' '}
            {t('VERIFY_CARD').TRY_AGAIN}
          </a>
        </div>
        <div className='sendverify__countdown'>{verificationCodeTimer}</div>
      </div>
    </div>
  );
};

export default VerificationCard;
